export function tipboxVote() {
	document.addEventListener("DOMContentLoaded", function () {

		if (typeof tipbox_ajax === "undefined") return;

		document.querySelectorAll(".tipbox-vote-form").forEach(form => {
			form.addEventListener("submit", function (e) {
				e.preventDefault();

				const container = form.closest(".tipbox-vote-container");
				const messageElement = form.querySelector(".vote-message");
				const voteCountElement = container.querySelector(".vote-count");
				const emailInput = form.querySelector("input[name='email']");
				const acceptSaveEmailInput = form.querySelector("input[name='accept_save_email']");
				const acceptSaveEmail = acceptSaveEmailInput && acceptSaveEmailInput.checked ? acceptSaveEmailInput.value : "";
				const postId = container.dataset.postId;
				const email = emailInput.value.trim();

				// Clear messages
				messageElement.textContent = "";
				messageElement.classList.remove("error", "success");

				// Disable form while processing
				form.querySelector("button").disabled = true;

				fetch(tipbox_ajax.ajax_url, {
					method: "POST",
					credentials: "same-origin",
					headers: { "Content-Type": "application/x-www-form-urlencoded" },
					body: new URLSearchParams({
						action: "tipbox_vote",
						nonce: tipbox_ajax.nonce,
						post_id: postId,
						email: email,
						accept_save_email: acceptSaveEmail
					}),
				})
					.then(response => response.json())
					.then(data => {
						if (data.success) {
							messageElement.classList.add("success");
							messageElement.textContent = data.data.message;

							voteCountElement.textContent = data.data.new_vote_count;

							// Reset input field
							emailInput.value = "";
						} else {
							messageElement.classList.add("error");
							messageElement.textContent = data.data.message;
						}
					})
					.catch(() => {
						messageElement.classList.add("error");
						messageElement.textContent = "Ett fel uppstod. Var god försök igen.";
					})
					.finally(() => {
						form.querySelector("button").disabled = false;
					});
			});
		});
	});


	// Helper function to toggle form elements
	function toggleFormElements(form, disabled) {
		const elements = form.querySelectorAll('input, button');
		elements.forEach(element => {
			element.disabled = disabled;
		});
	}
}

// Auto-initialize if window.tipbox_ajax exists (which means WP localized the script)
if (typeof window !== 'undefined' && window.tipbox_ajax) {
	tipboxVote();
}